/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ScanSubtype {
    SCAN_SUBTYPE_FLAT_LEFT_FOOT = 'SCAN_SUBTYPE_FLAT_LEFT_FOOT',
    SCAN_SUBTYPE_FLAT_RIGHT_FOOT = 'SCAN_SUBTYPE_FLAT_RIGHT_FOOT',
}
